import { GET_RESE_USER_TABLE_DATA, GET_RESE_USER_TABLE_DIVISION, GET_RESE_USER_TABLE_BANNER, GET_RESE_USER_TABLE_STATUS, UPDATE_RESE_USER_TABLE_DATA,GET_RESE_USER_TABLE_STORE } from "./actionTypes";

export const getReseUserTableDataInit = (pageNumber, pageSize, sortBy, sortDirection, filterCondition) => ({
    type: GET_RESE_USER_TABLE_DATA.INIT,
    pageNumber, pageSize, sortBy, sortDirection, filterCondition
});

export const getReseUserTableDataSuccess = (userTableData) => ({
    type: GET_RESE_USER_TABLE_DATA.SUCCESS,
    payload: userTableData
});

export const getReseUserTableDataError = (error) => ({
    type: GET_RESE_USER_TABLE_DATA.ERROR,
    payload: error
});

export const getReseUserTableDivisionInit = (divisionColumnPayload) => ({
    type: GET_RESE_USER_TABLE_DIVISION.INIT,
    divisionColumnPayload
});

export const getReseUserTableDivisionSuccess = (divisionData) => ({
    type: GET_RESE_USER_TABLE_DIVISION.SUCCESS,
    payload: divisionData
});

export const getReseUserTableDivisionError = (error) => ({
    type: GET_RESE_USER_TABLE_DIVISION.ERROR,
    payload: error
});

export const getReseUserTableStoreInit = (storeColumnPayload) => ({
    type: GET_RESE_USER_TABLE_STORE.INIT,
    storeColumnPayload
});

export const getReseUserTableStoreSuccess = (storeData) => ({
    type: GET_RESE_USER_TABLE_STORE.SUCCESS,
    payload: storeData
});

export const getReseUserTableStoreError = (error) => ({
    type: GET_RESE_USER_TABLE_STORE.ERROR,
    payload: error
});

export const getReseUserTableBannerInit = (bannerColumnPayload) => ({
    type: GET_RESE_USER_TABLE_BANNER.INIT,
    bannerColumnPayload
});

export const getReseUserTableBannerSuccess = (bannerData) => ({
    type: GET_RESE_USER_TABLE_BANNER.SUCCESS,
    payload: bannerData
});

export const getReseUserTableBannerError = (error) => ({
    type: GET_RESE_USER_TABLE_BANNER.ERROR,
    payload: error
});

export const getReseUserTableStatusInit = (statusColumnPayload) => ({
    type: GET_RESE_USER_TABLE_STATUS.INIT,
    statusColumnPayload
});

export const getReseUserTableStatusSuccess = (statusData) => ({
    type: GET_RESE_USER_TABLE_STATUS.SUCCESS,
    payload: statusData
});

export const getReseUserTableStatusError = (error) => ({
    type: GET_RESE_USER_TABLE_STATUS.ERROR,
    payload: error
});

export const updateReseUserTableDataInit = (tableData) => ({
    type: UPDATE_RESE_USER_TABLE_DATA.INIT,
    tableData
});

export const updateReseUserTableDataSuccess = (updatedData) => ({
    type: UPDATE_RESE_USER_TABLE_DATA.SUCCESS,
    payload: updatedData
});

export const updateReseUserTableDataError = (error) => ({
    type: UPDATE_RESE_USER_TABLE_DATA.ERROR,
    payload: error
});